import { ClassConstructor, instanceToPlain } from 'class-transformer';

import ChannelSubscriber from './ChannelSubscriber';
import LoggerFactory from '../../Util/Logger/LoggerFactory';

class Channel<Payload> {
  private readonly payloadModel: ClassConstructor<Payload>;

  private readonly eventName: string;

  private logger = LoggerFactory.get('Channel.ts');

  private readonly channelSubscriber: ChannelSubscriber<Payload>;

  constructor(
    payloadModel: ClassConstructor<Payload>,
    eventName: string,
    handler?: (payload: Payload) => void
  ) {
    this.payloadModel = payloadModel;
    this.eventName = eventName;
    if (!!handler) {
      this.channelSubscriber = new ChannelSubscriber<Payload>(eventName, payloadModel, handler);
    }
  }

  public unsubscribe(handler?: (payload: Payload) => void): void {
    if (!!handler) {
      new ChannelSubscriber<Payload>(this.eventName, this.payloadModel, handler).stop();
    } else {
      this.channelSubscriber.stop();
    }
  }

  public subscribe(handler?: (payload: Payload) => void): ChannelSubscriber<Payload> {
    if (!!handler) {
      return new ChannelSubscriber<Payload>(this.eventName, this.payloadModel, handler);
    } else {
      return this.channelSubscriber;
    }
  }

  public broadcast(payload: Payload): void {
    const detail = instanceToPlain<Payload>(payload);
    this.logger.log(`Channel "${this.eventName}" broadcast.`, detail);
    window.dispatchEvent(new CustomEvent(this.eventName, { detail }));
  }
}

export default Channel;
